const PUBLISHED = 'PUBLISHED';
const STATIC_PAGE_REGENERATION_TIME_IN_SECONDS = 60;

export { PUBLISHED, STATIC_PAGE_REGENERATION_TIME_IN_SECONDS };
